import { ChartCardSkeleton } from "./chart-card-skeleton";
import { ToolsWidgetSkeleton } from "./tools-widget-skeleton";

export function CardsSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      <ChartCardSkeleton />
      <ChartCardSkeleton />
    </div>
  );
}

export function ToolsSkeleton() {
  return <ToolsWidgetSkeleton />;
}
